import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { Button } from 'reactstrap';

const ConfirmMsg = ({
    open,
    title,
    message = "Are you sure you would like to delete",
    entryName = null,
    onConfirm,
    onDismiss,
    actionBtnTitle = "yes",
    cancelBtnTitle = null
}) => {
    return (
        <Dialog open={open} onClose={onDismiss} className='attention_block'>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText>{message} {entryName ? <b style={{ textTransform: "capitalize" }}>{entryName}?</b> : ""}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onDismiss} variant="secondary">{cancelBtnTitle || "Cancel"}</Button>
                <Button onClick={onConfirm}>{actionBtnTitle}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmMsg;
